// @flow
import _ from "lodash";

export const PERMANENT_TOGGLES = {
  DISABLE_LISTING_POSTS: "disable-listing-posts",
};

export const FAVORITES = "favorites";
export const PORTAL_LEAD_ACTIONS = {
  FAVORITED: "favorited",
  UNFAVORITED: "unfavorited",
  VIEWED: "viewed",
  HID: "hid",
  UNHID: "unhid",
};

export const SOCIAL_MEDIA_EXEMPTED_ERRORS = [
  "Page did not render when scrape was requested.",
  "Error validating access token: This may be because the user logged out or may be due to a system error.",
  "Invalid parameter",
  "Service temporarily unavailable",
  "An unexpected error has occurred. Please retry your request later.",
  "An unknown error occurred",
  "An unknown error has occurred.",
  "Status is a duplicate.",
  "Service Unavailable",
  "The request metadata specifies an invalid or empty video title.",
  "The request metadata specifies an invalid video description.",
  "Invalid subject for access token",
  "The url you supplied is invalid",
  "You have been temporarily blocked from performing this action.",
  "Tweet needs to be a bit shorter.",
  "Status is a duplicate.",
  "maps-origin.elmstreettechnology.com  Your content couldn't be shared, because this link goes against our Community Standards",
  "maps-origin.elmstreettechnology.com  No se pudo compartir tu contenido porque el enlace infringe nuestras Normas comunitarias.",
];

export const SUPPORT_EMAIL = "support@elmstreettechnology.com";

export const STATES = {
  AL: "AL",
  AK: "AK",
  AZ: "AZ",
  AR: "AR",
  CA: "CA",
  CO: "CO",
  CT: "CT",
  DE: "DE",
  DC: "DC",
  FL: "FL",
  GA: "GA",
  HI: "HI",
  ID: "ID",
  IL: "IL",
  IN: "IN",
  IA: "IA",
  KS: "KS",
  KY: "KY",
  LA: "LA",
  ME: "ME",
  MD: "MD",
  MA: "MA",
  MI: "MI",
  MN: "MN",
  MS: "MS",
  MO: "MO",
  MT: "MT",
  NE: "NE",
  NV: "NV",
  NH: "NH",
  NJ: "NJ",
  NM: "NM",
  NY: "NY",
  NC: "NC",
  ND: "ND",
  OH: "OH",
  OK: "OK",
  OR: "OR",
  PA: "PA",
  RI: "RI",
  SC: "SC",
  SD: "SD",
  TN: "TN",
  TX: "TX",
  UT: "UT",
  VT: "VT",
  VA: "VA",
  WA: "WA",
  WV: "WV",
  WI: "WI",
  WY: "WY",
};

export const STATE_NAMES = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District Of Columbia",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

export const LISTING_STATUSES = {
  // OFF_MARKET: "Off Market", // Don't display off market on Sites
  PENDING: "Pending",
  ACTIVE: "Active",
  SOLD: "Sold",
};

type ConstantCheckType = {
  constant: Object,
  filters?: Array<string> | string | null,
  label: string,
};

export function assertConstant(
  constantCheck: ConstantCheckType
): boolean | Error {
  if (
    !(
      constantCheck.constant &&
      constantCheck.hasOwnProperty("filters") &&
      constantCheck.label
    )
  ) {
    throw new Error(
      "Asserting a constant requires an object with the following keys: constant, filters, and a label"
    );
  }

  if (Array.isArray(constantCheck.filters)) {
    if (!constantCheck.filters.length) {
      return true;
    }

    const invalidValues = _.compact(
      _.map(constantCheck.filters, (value) => {
        return !_.includes(constantCheck.constant, value) ? value : null;
      })
    );

    if (invalidValues && invalidValues.length) {
      throw new Error(
        `Invalid values, ${invalidValues.join(", ")}, received for: ${
          constantCheck.label
        }, please modify these values and try again`
      );
    }

    return true;
  }

  if (!constantCheck.filters) {
    return true;
  }

  if (_.includes(constantCheck.constant, constantCheck.filters)) {
    return true;
  }

  throw new Error(
    `Invalid value, ${
      Array.isArray(constantCheck.filters)
        ? constantCheck.filters.join(", ")
        : constantCheck.filters || ""
    }, received for: ${
      constantCheck.label
    }, please modify this value and try again`
  );
}

/**
 * This Fn asserts an array of constants against user-provided values
 */
export function assertConstants(constantChecks: Array<ConstantCheckType>) {
  _.each(constantChecks, (constantCheck: ConstantCheckType) => {
    return assertConstant(constantCheck);
  });
}

export const LISTING_STATUS = {
  ACTIVE: "Active",
  OFF_MARKET: "Off Market",
  PENDING: "Pending",
  SOLD: "Sold",
};

export const LISTING_TYPE = {
  SINGLE_FAMILY: "Single Family",
  TOWNHOUSE: "Townhouse",
  CONDO: "Condo",
  COMMERCIAL: "Commercial",
  MULTIFAMILY: "Multifamily",
  LAND: "Land",
  MOBILE: "Mobile",
  RESIDENTIAL_INCOME: "Residential Income",
  BUSINESS_OPPORTUNITY: "Business Opportunity",
  OTHER: "Other",
};
export const PROPERTY_PLACEHOLDER_IMAGE = "property-placeholder.jpg";
export const CDN_IMAGE_SERVER_URL =
  process.env.CDN_IMAGE_SERVER_URL ||
  "https://mls-photos.elmstreettechnology.com";

export const MAP_IMAGE_SERVICE_URL = (
  process.env.MAP_IMAGE_SERVICE_URL || "https://maps.elmstreettechnology.com"
).replace(/\/$/, "");

export const MAP_PROVIDER_INFORMATION = {
  url: `https://api.mapbox.com/styles/v1/mapbox/{id}/tiles/{z}/{x}/{y}?access_token=${
    process.env.MAPBOX_ACCESS_TOKEN
  }`,
  maxZoom: 20,
  attribution:
    "Map data &copy; <a href='https://www.openstreetmap.org/'>OpenStreetMap</a> contributors, <a href='https://creativecommons.org/licenses/by-sa/2.0/'>CC-BY-SA</a>, Imagery © <a href='https://www.mapbox.com/'>Mapbox</a>;",
  tileLayers: {
    street: "streets-v11",
    satellite: "satellite-streets-v11",
  },
};

export const BLOG_POST_TYPE = {
  NEW: "new",
  UPDATED: "updated",
  SOLD: "sold",
  PCG: "pcg",
  TOH: "toh",
  GENERAL_INTEREST: "generalInterest",
  MARKET_ANALYSIS: "marketAnalysis",
  OPEN_HOUSE: "openHouse",
  VIDEO: "video",
};

export const OPEN_HOUSE = {
  TYPE: { VIRTUAL: "virtual", TRADITIONAL: "traditional" },
};

export const OPEN_HOUSE_LISTING_SEARCH_RAW_FILTERS = [
  "minopenHouse",
  "maxopenHouse",
  "openHouseType",
];

export const PRODUCT_TYPES = {
  DMS: "dms",
  SOCIAL_PRO: "social",
  IDX_FREE: "idx-free",
  IDX: "idx",
};

export const RED = {
  TENANT: "real-estate-digital",
  SOCIAL_ACCOUNT: "real estate digital",
  URL_PATH: "/blog",
};

export const BRIGHT = {
  TENANT: "bright-mls",
};

export const TENANTS_DELAY_SOCIAL_POSTS = [RED.TENANT, BRIGHT.TENANT];

export const DEFAULT_SIMILAR_LISTING_LIMIT = 6;
export const DEFAULT_SITE_SORTNAME = "priceDown";

export const ALLOWED_BLOG_PRODUCT_TYPES = ["dms", "social"];
export const PROVIDERS_OUTSIDE_US = [156, 233];

export const DATASTORE_PROVIDERS_THAT_REQUIRE_OFFICE_NAME_LOOKUPS_FOR_LISTINGS = [
  102,
  35,
  110,
  116,
  145,
  146,
  147,
  158,
  150,
  171,
  180,
  185,
  186,
  194,
  195,
  211,
];
export const DATASTORE_PROVIDERS_THAT_REQUIRE_OFFICE_PHONE_LOOKUPS_FOR_LISTINGS = [
  151,
];
export const DATASTORE_PROVIDERS_THAT_REQUIRE_AGENT_PHONE_LOOKUPS_FOR_LISTINGS = [
  151,
];

export const TESTIMONIAL_STATUS = {
  DRAFT: "draft",
  PUBLISHED: "published",
};

export const SELLER_LEAD = {
  MAXIMUM_COMPETING_PCT_PRICE_RANGE: 25,
  MINIMUM_CONFIDENCE_SCORE: 75,
};
